<div class="modal-header">
  <h5 class="modal-title">Upload image and get link</h5>
  <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="">&times;</span>
  </button>
</div>
<form class="admin-form"  id="addCategoryForm">
  <div class="modal-body">
    <div class="user-form">
      <div class="form-group mb-0">
        <label>Choose image*</label>
        <input id="img_upload" name="file-upload-field"
          accept=".png, .jpg, .jpeg, .webp"
          type="file" class="form-control "
          (change)="fileChangeEvent($event)" required>
      </div>
    </div>
    @if (imageChangedEvent) {
      <div class="user-form">
        <div class="pt-3 form-group">
          <label>Crop image</label>
          <image-cropper
            (imageCropped)="imageCropped($event)"
            (loadImageFailed)="loadImageFailed()"
            [aspectRatio]=aspectRatio
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            format="png">
          </image-cropper>
          @if (loading) {
            <div class="progress" style="height: 20px;">
              <div class="progress-bar" role="progressbar"
                [style]="{'width': progress+'%'}"
                aria-valuemax="100">{{progress}}%
              </div>
            </div>
          }
        </div>
        @if (url) {
          <div class="pl-2">
            <p class="text-success"
              >Link copied to your clipboard.
              <span (click)="copyToClipboard()" class="text-link">Click here to Copy again.</span></p>
            </div>
          }
        </div>
      }
    </div>
    <div class="modal-footer justify-content-end">
      @if (url) {
        <button (click)="UploadNewImage()" class="btn btn-primary btn-dashboard" type="button">Upload another image</button>
      }
      <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      <button (click)="uploadImage($event)" class="btn btn-primary btn-dashboard" type="button">Crop</button>
    </div>
  </form>

